import {
  Material,
  Mesh,
} from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { store } from 'src/app/store';
import {
  modelLoadProgress,
  modelLoadError,
} from 'src/state';

import { scene } from './scene';

const loader = new GLTFLoader();

export function loadGltf(fileName: string, material: Material, numberOfModels: number) {
  let loaded = 0;
  let total = 1;

  loader.load(
    fileName,
    function addObjToScene(gltf) {
      // apply the material to all objects in the gltf
      gltf.scene.traverse(function ( child ) {
        if (child instanceof Mesh) {
          child.material = material;
        }
      });

      scene.add(gltf.scene);

      const progress = (total - loaded) / total / numberOfModels;
      store.dispatch(modelLoadProgress(progress));
    },
    function updateLoadingStatement(xhr) {
      total = xhr.total;

      const progress = (xhr.loaded - loaded) / total / numberOfModels;
      store.dispatch(modelLoadProgress(progress));

      loaded = xhr.loaded;
    },
    function errorMessage(error) {
      store.dispatch(modelLoadError(error.message));
      console.error(`failed to load ${fileName}`);
    },
  );
}
